import { render, staticRenderFns } from "./OrganizationDetailsMenu.vue?vue&type=template&id=53381785&"
import script from "./OrganizationDetailsMenu.vue?vue&type=script&lang=js&"
export * from "./OrganizationDetailsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports